import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { logout } from 'src/app/redux/actions/user.actions';
import { UserState } from 'src/app/redux/reducers/user.reducer';
import { AuthService } from 'src/app/services/auth.service';
import { TokenService } from 'src/app/services/token.service';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrl: './password.component.scss',
  standalone: false

})
export class PasswordComponent {
  passwordFields = { password: '', confirmPassword: '', newPassword: '' };
  constructor(private auth: AuthService,
    private token: TokenService,
    private router: Router,
    private store: Store<{ user: UserState }>,



  ) { }
  guardarDatos() {

    this.auth.changePassword({
      oldPassword: this.passwordFields.password,
      newPassword: this.passwordFields.newPassword,
    }).subscribe(data => {
      console.log(data);
      alert('Contraseña cambiada correctamente, inicie sesión nuevamente para continuar');
      this.token.remove();
      this.store.dispatch(logout());
      this.router.navigateByUrl('/login');
    }, (error) => {
      console.log(error);
      alert('Error al cambiar la contraseña, usuario o contraseña incorrectas');
    });
  }
}
